const purchase = {
  title: 'HitPaw Online Pro',
  subTitle: 'Choose the right plan with simple & transparent pricing',
  monthlyUppercase: 'MONTHLY',
  montly: 'Monthly',
  free: 'FREE',
  yearlyUppercase: 'YEARLY',
  yearly: 'Annual',
  inService: 'In Service',
  buyBtn: 'Buy Now',
  freeTips1: 'Supports maximum file size of 20MB',
  freeTips2: '6 files per day',
  freeTips3: 'Normal processing speed',
  freeTips4: 'Normal download speed',
  freeTips5: 'change background of 1 pic a day',
  freeTips52: 'change background of 3 pic a day',
  freeTips6: 'Access to all free tools',
  vipTips1: 'Unlimited file size',
  vipTips2: 'Unlimited files per day',
  vipTips3: 'Faster download speed',
  vipTips4: 'Faster processing speed',
  vipTips5: 'Unlimited',
  vipTips6: 'change image background without limits per day',
  vipTips7: 'Access to all tools & premium features',
  vipTips8: 'Renew automatically and cancel any time.',
  vipTips9: 'No video size and quantity limit',
  vipTips10: 'Remove image backgrounds without limits',
  vipTips11: 'Faster video processing and download speed',
  vipTips12: 'Access to all free tools & premium features',
  acceptTitle: 'We Accept:',
  modalTitle: 'Upgrade to Pro to access all premium features',
  total: 'Total',
  enterCode: 'Enter code',
  SignUpToPurchaseBtn: 'Sign Up to Purchase',
  purchaseBtn: 'Go to Purchase',
  saveTips: 'Save Up to {{num}}%',
  discount: 'Discount',
  purchaseTips: 'Renew automatically and cancel any time.',
  tips: 'Tips:',
  promoCodeInvalidTips: 'Your promo code is invalid',
};

export default purchase;
